module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8450/img/hubspot-tools-logo.png"